interface Props {
  highlightColor?: string;
  width?: number;
  height?: number;
}

export const DropIceCreamIcon = ({ highlightColor, width, height }: Props) => {
  const color = "#00000";

  return (
    <svg
      id="Layer_2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 150.19 197.53"
      width={width}
      height={height}
    >
      <g id="Layer_1-2">
        <path
          fill={highlightColor || color}
          d="m28.87,163.2l-.5-1.71-.51.41c-2.43-2.99-4.33-6.27-5.65-9.75-2.37-6.25-2.35-11.82-2.34-15.51,0-2.37.17-4.75.48-7.08l4.96.66c-.28,2.12-.43,4.29-.44,6.44-.01,3.51-.03,8.33,2.02,13.72,1.13,2.98,2.76,5.79,4.85,8.37l2.37,2.92-5.24,1.53Z"
        />
        <path
          fill={highlightColor || color}
          d="m118.27,161.32l-4.41-2.36c1.44-2.68,2.62-5.52,3.51-8.42,1.37-4.47,2.07-9.14,2.07-13.88,0-14.11-6.23-27.38-17.1-36.4l3.19-3.85c12.01,9.97,18.9,24.64,18.9,40.24,0,5.23-.77,10.4-2.29,15.35-.99,3.21-2.29,6.35-3.89,9.32Z"
        />
        <path
          fill={highlightColor || color}
          d="m138.85,180.97c-.83,0-19.66,0-46.7,0v-5c27.05,0,45.88,0,46.71,0h.19c.32-.01.82-.05,1.4-.2,1.08-.28,2.08-.85,2.88-1.66,1.21-1.2,1.87-2.79,1.87-4.47,0-3.5-2.84-6.34-6.34-6.34-2.44,0-5.55,0-8.66.01-6.49.01-12.63.03-13.74-.01-1.04-.04-1.94-.51-2.47-1.29-.57-.83-.93-2.25.56-4.29l3.93,2.89c.04-.37-.01-.9-.36-1.41-.43-.64-1.07-.88-1.48-.9,1.02.04,7.67.03,13.54.01,3.12,0,6.23-.01,8.67-.01,6.25,0,11.34,5.09,11.34,11.34,0,3.03-1.19,5.87-3.34,8.01-1.42,1.42-3.21,2.45-5.15,2.95-1.04.27-1.94.34-2.52.36h-.33Z"
        />
        <path
          fill={highlightColor || color}
          d="m120.3,197.53h-18c-4.05,0-7.35-3.29-7.35-7.35s3.3-7.35,7.35-7.35h18c4.05,0,7.35,3.3,7.35,7.35s-3.3,7.35-7.35,7.35Zm-18-9.69c-1.29,0-2.35,1.05-2.35,2.35s1.05,2.35,2.35,2.35h18c1.29,0,2.35-1.05,2.35-2.35s-1.05-2.35-2.35-2.35h-18Z"
        />
        <path
          fill={highlightColor || color}
          d="m84.66,190.21l-48.68-.02c-1.65-.23-3.01-.86-4.04-1.89-1.66-1.65-1.82-3.66-1.93-5.13-.06-.77-.12-1.49-.36-1.76-.26-.29-1.11-.56-2.73-.44l-.37-4.99c3.11-.22,5.41.49,6.85,2.13,1.34,1.52,1.48,3.34,1.58,4.67.09,1.14.16,1.67.48,1.98.22.22.57.37,1.04.46h48.01c.78-.05,1.36-.23,1.6-.5.25-.29.27-.95.26-1.93,0-1.44-.01-3.41,1.46-5.01,1.39-1.51,3.57-2.1,6.48-1.77l-.58,4.97c-1.51-.18-2.13.08-2.22.19-.15.16-.14,1.1-.14,1.61,0,1.49.01,3.52-1.51,5.25-1.18,1.34-2.92,2.08-5.15,2.2h-.06Z"
        />
        <path
          fill={highlightColor || color}
          d="m28.76,180.97l-17.9-.05C4.69,179.73.12,175.01,0,169.7c-.07-2.89,1.18-5.91,3.33-8.06.78-.78,2.45-2.19,4.91-2.9,1.45-.42,2.63-.43,3.08-.43,2.11-.02,8.43-.04,17.31,0l-.03,5c-8.84-.05-15.14-.02-17.23,0-.31,0-.95,0-1.74.24-1.43.41-2.4,1.28-2.75,1.63-1.17,1.17-1.91,2.91-1.87,4.42.07,2.87,2.88,5.58,6.59,6.39h17.17v5Z"
        />
        <path
          fill={highlightColor || color}
          d="m28.67,163.3l-.11-5c.54-.01,1.08-.06,1.61-.15,5.35-.9,8.31-5.56,11.16-10.08,2.64-4.18,5.38-8.5,10.07-9.41,5.47-1.06,9.62,3.13,13.28,6.83,2.93,2.96,5.69,5.76,8.21,5.18,2.03-.46,3.06-2.86,4.51-6.77,1.59-4.29,3.39-9.16,8.38-11.16,7-2.8,14.33,2.45,20.8,7.08,4.18,2.99,8.91,6.39,10.89,5.21,1.05-.63,3.26-3.52,1.22-16.86-.71-4.67-2.26-9.18-4.61-13.42l4.38-2.42c2.63,4.75,4.37,9.83,5.18,15.08,1.19,7.77,2.11,18.49-3.59,21.91-4.79,2.87-10.41-1.16-16.37-5.43-5.42-3.88-11.57-8.29-16.02-6.5-2.93,1.18-4.2,4.62-5.55,8.26-1.53,4.14-3.27,8.83-8.1,9.92-5.22,1.17-9.27-2.93-12.85-6.54-3.05-3.08-5.93-6-8.78-5.44-2.57.5-4.53,3.59-6.8,7.18-3.12,4.93-7.01,11.07-14.56,12.34-.77.13-1.55.2-2.32.22Z"
        />
        <path
          fill={color}
          d="m24.58,132.5c-4.16,0-8.02-2.12-10.14-5.71-2.51-4.23-2.03-9.58,1.07-13.43C11.85,90.39.91,20.98.1,9.48-.04,7.49-.41,2.2,3.1.48c3.47-1.7,7.72,1.5,9.54,2.87,8.97,6.75,55.54,51.83,82.99,78.59,2.64.23,6.57,1.13,9.03,4.29.2.25,1.91,2.55,2,5.87.2,7.72-13.42,17.71-37.39,27.39-13.58,5.49-27.96,9.81-42.75,12.84l-.14.02c-.61.09-1.21.13-1.81.13ZM5.36,5c-.15.31-.47,1.34-.27,4.14.64,9.13,8.45,60.03,15.54,104.62l.2,1.26-.9.9c-2.23,2.23-2.73,5.73-1.19,8.33,1.36,2.29,4.1,3.57,6.86,3.18,14.46-2.97,28.53-7.2,41.81-12.56,28.3-11.43,34.33-20.21,34.26-22.62-.04-1.69-.96-2.94-.97-2.96-1.58-2.03-4.88-2.36-6.23-2.4l-.97-.03-.69-.68C70.85,64.77,18.78,14.23,9.63,7.35c-2.73-2.05-3.88-2.33-4.27-2.35Z"
        />
        <rect fill={color} x="24.15" y="24.18" width="4" height="60.68" />
        <rect fill={color} x="68.24" y="60.93" width="4" height="38.06" />
        <polygon
          fill={color}
          points="48.24 108.37 44.24 108.27 46.07 41.37 9.47 27.9 10.85 24.14 50.15 38.61 48.24 108.37"
        />
        <rect
          fill={color}
          x="40.97"
          y="26.21"
          width="4"
          height="56.07"
          transform="translate(-19.75 83.48) rotate(-76.61)"
        />
        <rect
          fill={color}
          x="51.33"
          y="49.6"
          width="4"
          height="55.23"
          transform="translate(-32.08 116.1) rotate(-79.84)"
        />
      </g>
    </svg>
  );
};
